import { Alert, Snackbar } from "@mui/material";
import React from "react";

function AddedMailSnackbar({emailAddedToList, handleCloseEmailAddedToList, emailForUpdates}) {
    return (<Snackbar anchorOrigin={{
  vertical: 'bottom',
  horizontal: 'center'
  }} open={emailAddedToList} autoHideDuration={4000} onClose={handleCloseEmailAddedToList}>
    <Alert variant="filled" onClose={handleCloseEmailAddedToList} severity="success" sx={{
  width: '100%'
  }}>
      The email "{emailForUpdates}" was added to the list, thank you! 🎉
    </Alert>
  </Snackbar>);
  }

  export default AddedMailSnackbar;